module.exports = __webpack_public_path__ + "static/img/extend_icon_b.527f7a5d.c0572e54.svg";